<template>
    <div style='height: 1024px; padding: 0.45em; width: 100%'>
        <iframe :src='imFactura' frameborder='0' scrolling='yes' style='overflow: scroll; height: 100%; width: 49%; float: left; ' height='100%' width='49%' align='right'></iframe>
        <v-container fluid>
            <div>
                <v-row justify='space-between'>
                    <v-col sm='4' md='3'>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn small fab v-on:click='syncMiami'>
                                        <v-icon>swap_vertical_circle</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Sincronizar Información de Miami</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn small fab icon color='secondary' v-on:click='exportar'>
                                        <v-icon>file_download</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Descargar MS Excel</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn small fab v-on:click='refrescarContenedores'>
                                        <v-icon>loop</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Refrescar lista de contenedores</span>
                        </v-tooltip>
                    </v-col>
                    <v-col sm='8' md='6'>
                        <v-select label='Contenedor' v-model='contenedor' :hint='`MAWB: ${contenedor.mawb}, Guías: ${contenedor.cantidad_guias}`' :items='contenedores_entries' item-text='numero_contenedor' item-value='id' persistent-hint return-object single-line dense>
                            <template slot='selection' slot-scope='contenedor'>
                                <!-- HTML that describe how select should render selected items -->
                                <span>{{ contenedor.item.fecha_str }} - {{ contenedor.item.numero_contenedor }}</span>
                            </template>
                            <template slot='item' slot-scope='contenedor'>
                                <!-- HTML that describe how select should render items when the select is open -->
                                <span>{{ contenedor.item.fecha_str }} - {{ contenedor.item.numero_contenedor }}</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col sm='4' md='2'>
                        <span>
                            <v-tooltip bottom>
                                <template v-slot:activator='{ on }'>
                                    <span v-on='on'>
                                        <v-btn small fab icon v-on:click='cerrarGuias'>
                                            <v-icon>mdi-alpha-c-box</v-icon>
                                        </v-btn>
                                    </span>
                                </template>
                                <span>Cerrar guía</span>
                            </v-tooltip>
                        </span>
                        <span>
                            <v-tooltip bottom>
                                <template v-slot:activator='{ on }'>
                                    <span v-on='on'>
                                        <v-btn small fab icon v-on:click='cargarGuias'>
                                            <v-icon>assignment_returned</v-icon>
                                        </v-btn>
                                    </span>
                                </template>
                                <span>Cargar guía</span>
                            </v-tooltip>
                        </span>
                        <span>
                            <v-tooltip bottom>
                                <template v-slot:activator='{ on }'>
                                    <span v-on='on'>
                                        <v-btn small fab icon v-on:click='marcarGuias'>
                                            <v-icon>{{ marcarCheckox ? "mdi-checkbox-blank-outline" : "mdi-checkbox-multiple-marked-outline" }}</v-icon>
                                        </v-btn>
                                    </span>
                                </template>
                                <span>Marcar guías</span>
                            </v-tooltip>
                        </span>
                    </v-col>
                </v-row>
            </div>

            <div v-if='hawb_numero'>
                <v-row justify='space-between'>
                    <v-col sm='12' md='5'>
                        <h4>
                            {{hawb_numero}} - {{hawb_cliente}}
                            <br />
                            {{hawb_modalidad}}
                        </h4>
                    </v-col>
                    <v-col sm='12' md='3'>
                        <v-currency-field label='Monto Guía' v-model='hawb_monto' locale='en-US' prefix='$' :decimalLength='c_three' dense />
                    </v-col>
                    <v-col sm='12' md='3'>
                        <v-currency-field label='Saldo' v-model='hawb_saldo' locale='en-US' prefix='$' :decimalLength='c_three' dense readonly />
                    </v-col>
                    <v-col sm='12' md='1'>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn small fab icon color='secondary' v-on:click='verFactura'>
                                        <v-icon>wallpaper</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Recargar Imagen</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row justify='space-between'>
                    <v-col sm='12' md='12'>
                        <v-card dark>
                            <v-combobox dense v-model='hawb_model' :items='hawb_partidas' :loading='hawb_isLoading' :search-input.sync='hawb_sync' color='white' hide-no-data hide-selected no-filter @change='hawb_onChange' item-text='descripcion' item-value='API' label='Artículo' placeholder='Empiece a escribir para iniciar búsqueda' prepend-icon='mdi-database-search' return-object></v-combobox>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row justify='space-between'>
                    <v-col sm='12' md='3'>
                        <v-text-field label='Partida' type='text' v-model='hawb_partida' dense />
                    </v-col>

                    <v-col sm='12' md='2'>
                        <v-text-field label='Cantidad' type='number' hide-details single-line v-model='hawb_cantidad' dense />
                    </v-col>

                    <v-col sm='12' md='2'>
                        <v-currency-field label='Precio' v-model='hawb_precio' locale='en-US' prefix='$' :decimalLength='c_three' dense />
                    </v-col>
                    <v-col sm='12' md='1'>
                        <v-btn v-on:click='hawb_agregarLinea' color='green darken-1'>+</v-btn>
                    </v-col>
                </v-row>

                <v-row justify='space-between'>
                    <v-col sm='12'>
                        <v-data-table stripes :headers='partidas_headers' :items='hawb_tabla_lineas' class='elevation-1' dense>
                            <template v-slot:no-data>
                                <v-alert :value='true' color='amber accent-3' icon='warning'>Sin artículos :(</v-alert>
                            </template>
                            <template v-slot:item.cantidad='{ value }'>
                                <span>{{ formatAmount(value) }}</span>
                            </template>
                            <template v-slot:item.precio='{ value }'>
                                <span>{{ formatMoney(value) }}</span>
                            </template>
                            <template v-slot:item.total='{ value }'>
                                <span>{{ formatMoney(value) }}</span>
                            </template>
                            <template v-slot:item.action='{ item }'>
                                <v-icon small @click='hawb_borrarLinea(item)'>delete</v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <v-row justify='space-between' v-if='hawb_alert_message'>
                    <v-col sm='12' md='12'>
                        <v-alert type='info' style='text-align: center;'>Cantidad incorrecta!</v-alert>
                    </v-col>
                </v-row>

                <v-row justify='space-between' v-if='hawb_alert_message2'>
                    <v-col sm='12' md='12'>
                        <v-alert type='info' style='text-align: center;'>No se puede aplicar - Montos no coinciden!</v-alert>
                    </v-col>
                </v-row>

                <v-row justify='space-between'>
                    <v-col sm='12' md='3' offset='3'>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn color='warning' v-on:click='hawb_cancelar'>
                                        <v-icon>exit_to_app</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Cancelar</span>
                        </v-tooltip>
                    </v-col>
                    <v-col sm='12' md='3'>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn color='warning' v-on:click='hawb_undo_aplicar'>
                                        <v-icon>mdi-undo-variant</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Devolver aplicación de la guía</span>
                        </v-tooltip>
                    </v-col>
                    <v-col sm='12' md='3'>
                        <v-tooltip bottom>
                            <template v-slot:activator='{ on }'>
                                <span v-on='on'>
                                    <v-btn color='primary' v-on:click='hawb_aplicar'>
                                        <v-icon>done</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Aplicar IMS</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </div>
            <div v-else>
                <v-row justify='space-between'>
                    <v-col sm='12'>
                        <v-data-table stripes :headers='contenedor_table_headers' :items='contenedor_guias' :sort-by.sync='contenedor_sort_by' :sort-desc.sync='contenedor_sort_desc' :items-per-page.sync='contenedor_items_per_page_sync' :page.sync='contenedor_page_sync' class='elevation-1' dense>
                            <template v-slot:no-data>
                                <v-alert :value='true' color='amber accent-3' icon='warning'>Favor indicar criterio de selección y presionar el botón de consultar :(</v-alert>
                            </template>
                            <template v-slot:item.estado='{ item }'>
                                <span v-if='item.documento_compra.trim()'>
                                    <span v-if='item.totalProcesado > 0'>
                                        <img src='/guia_verde.jpg' />
                                    </span>
                                    <span v-else>
                                        <img src='/guia_amarilla.jpg' />
                                    </span>
                                </span>
                                <span v-else>
                                    <img src='/guia_roja.jpg' />
                                </span>
                            </template>
                            <template v-slot:item.hawb='{ item }'>
                                <div class='centered'>
                                    <span v-if='item.exonerar'>
                                        <span class='yellow lighten-0'>{{ item.hawb }}</span>
                                    </span>
                                    <span v-else>
                                        <span>{{ item.hawb }}</span>
                                    </span>
                                    <br />
                                    <span style='text-align: center'>{{ item.usuario === "_" ? "" : item.usuario }}</span>
                                </div>
                            </template>
                            <template v-slot:item.consignatario='{ item }'>
                                <div class='centered'>
                                    <span>{{ item.consignatario }}</span>
                                    <br />
                                    <span class='yellow lighten-0' style='text-align: center'>{{ item.cerrado ? "GUIA CERRADA" : "" }}</span>
                                </div>
                            </template>
                            <template v-slot:item.cantidad='{ value }'>
                                <span>{{ formatAmount(value) }}</span>
                            </template>
                            <template v-slot:item.valor='{ value }'>
                                <span>{{ formatMoney(value) }}</span>
                            </template>
                            <template v-slot:item.action='{ item }'>
                                <v-tooltip left>
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon small class='mr-2' @click='editArticulos(item)' v-bind='attrs' v-on='on'>edit</v-icon>
                                    </template>
                                    <span>Editar Guía</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon small @click='verFactura(item)' v-bind='attrs' v-on='on'>zoom_in</v-icon>
                                    </template>
                                    <span>Ver Factura</span>
                                </v-tooltip>

                                <v-tooltip bottom color='red'>
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon style='padding-left: 1rem;' small @click='item.cerrado = !item.cerrado' v-bind='attrs' v-on='on'>{{ item.cerrado ? "mdi-checkbox-marked-outline" : "mdi-checkbox-blank-outline" }}</v-icon>
                                    </template>
                                    <span>Cerrar la Guía</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </v-container>

        <v-dialog v-model='dlg_dialog' :max-width='dlg_options.width' :style='{ zIndex: dlg_options.zIndex }' @keydown.esc='dlg_cancel'>
            <v-card>
                <v-toolbar dark :color='dlg_options.color' dense flat>
                    <v-toolbar-title class='white--text'>{{ dlg_title }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text v-show='!!dlg_message' class='pa-4'>{{ dlg_message }}</v-card-text>
                <v-card-actions class='pt-0'>
                    <v-spacer></v-spacer>
                    <v-btn color='primary darken-1' text @click.native='dlg_agree'>Yes</v-btn>
                    <v-btn color='grey' text @click.native='dlg_cancel'>Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    // import gvars from "../../varglobals";

    import { mapGetters } from "vuex";

    const c_REMOTE_URL = (process.env.VUE_APP_BASE_URL_SERVER || "http://localhost:8951") + '/'

    const CONTENEDOR_NEXT_DAY = [
        {
            id: "NEXT+DAY+ECONOMY",
            fecha_str: "MODALIDAD",
            numero_contenedor: "Next Day /Economy",
            mawb: 0,
            peso: 0,
            modalidad: 0,
            cantidad_guias: 0
        }
    ];

    export default {
        name: "ims",
        data() {
            return {
                c_three: 3,

                contenedor: CONTENEDOR_NEXT_DAY[0],
                contenedores_entries: CONTENEDOR_NEXT_DAY,

                contenedor_sort_by: "HAWB",
                contenedor_sort_desc: true,
                contenedor_page_sync: 0,
                contenedor_items_per_page_sync: 10,
                contenedor_guias: [],
                contenedor_table_headers: [
                    { text: "", align: "center", value: "estado", sortable: false },
                    { text: "HAWB", align: "left", value: "hawb" },
                    { text: "Cliente", value: "consignatario" },
                    { text: "Cantidad", value: "cantidad" },
                    { text: "Precio Venta", value: "valor" },
                    { text: "Acción", value: "action", sortable: false }
                ],

                marcarCheckox: true,

                hawb_id: -1,
                hawb_numero: "",
                hawb_cliente: "",
                hawb_saldo: "",
                hawb_modalidad: "",
                hawb_monto: "",

                hawb_sync: null,
                hawb_model: null,
                hawb_model_id: -1,
                hawb_partida: "",
                hawb_precio: "",
                hawb_cantidad: "",
                hawb_isLoading: false,
                hawb_alert_message: null,
                hawb_alert_message2: null,
                hawb_documento_compra: "",

                hawb_search_count: 0,
                hawb_search_entries: [],
                hawb_tabla_lineas: [],

                partidas_headers: [
                    { text: "Partida", value: "partida" },
                    { text: "Descripción", value: "contenido" },
                    { text: "Cantidad", value: "cantidad" },
                    { text: "Precio Venta", value: "precio" },
                    { text: "Total", value: "total" },
                    { text: "Acción", value: "action", sortable: false }
                ],
                items: [],
                imFactura: "/NoImage.png",
                dlg_dialog: false,
                dlg_resolve: null,
                dlg_reject: null,
                dlg_message: null,
                dlg_title: null,
                dlg_options: {
                    color: 'primary',
                    width: 290,
                    zIndex: 200
                }

            };
        },
        methods: {
            ...mapGetters(["getUser"]),
            hawb_onChange(value) {
                this.hawb_partida = value.partida;
            },
            formatAmount(amount) {
                return amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            },
            formatMoney(amount) {
                return "$" + amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            },
            hawb_agregarLinea() {
                let id = this.hawb_model_id;
                let precio = Number(this.hawb_precio);
                let cantidad = Number(this.hawb_cantidad);

                const values = this.hawb_tabla_lineas;

                this.hawb_alert_message = null;
                this.hawb_alert_message2 = null;

                if (!isNaN(cantidad) && cantidad > 0) {
                    if (id <= 0) {
                        id = values.map(x => x.id).reduce((a, b) => Math.max(a, b), 1);
                    }

                    if (isNaN(precio) || precio <= 0) {
                        const subtotal = this.hawb_tabla_lineas
                            .map(x => x.total)
                            .reduce((a, b) => a + b, 0);

                        if (subtotal < this.hawb_monto) {
                            precio = (this.hawb_monto - subtotal) / cantidad;
                        }
                    }

                    const total = cantidad * precio;

                    const data = {
                        id,
                        total,
                        precio,
                        cantidad,
                        partida: this.hawb_partida || '000000000000',
                        contenido: (this.hawb_model.descripcion || this.hawb_model).replace(/"/g, "")
                    };

                    if (this.hawb_model_id >= 0) {
                        const pos = values.findIndex(x => x.id === id);

                        this.hawb_tabla_lineas = values
                            .slice(0, pos)
                            .concat(data)
                            .concat(values.slice(pos + 1));
                    } else {
                        const list = values.map(x => x.id)
                        data.id = list.length ? Math.min(...list) - 1 : -1;

                        this.hawb_tabla_lineas = values.concat(data);
                    }
                    this.hawb_model = null;
                    this.hawb_precio = "";
                    this.hawb_partida = "";
                    this.hawb_cantidad = "";

                    const suma = this.hawb_tabla_lineas
                        .map(x => x.total)
                        .reduce((a, b) => a + b, 0);
                    this.hawb_saldo = this.hawb_monto - suma;
                } else {
                    this.hawb_alert_message = "info";
                }
                this.hawb_alert_message2 = null;
            },
            hawb_borrarLinea(item) {

                this.hawb_tabla_lineas = this.hawb_tabla_lineas.filter(x => x.id !== item.id);

                const suma = this.hawb_tabla_lineas
                    .map(x => x.total)
                    .reduce((a, b) => a + b, 0);
                this.hawb_saldo = this.hawb_monto - suma;

                this.hawb_alert_message2 = null;
            },
            hawb_cancelar() {
                this.hawb_numero = null;
                this.hawb_alert_message = null;
                this.hawb_alert_message2 = null;
            },
            async hawb_aplicar() {
                try {
                    const usuario = this.getUser().username;

                    const suma = this.hawb_tabla_lineas
                        .map(x => x.total)
                        .reduce((a, b) => a + b, 0);
                    if (Math.abs(suma - this.hawb_monto) < 0.01) {
                        const data = {
                            contenedor_id: this.contenedor.id,

                            hawb: this.hawb,
                            hawb_monto: this.hawb_monto,
                            hawb_numero: this.hawb_numero,
                            lineas: this.hawb_tabla_lineas,
                            usuario
                        };

                        this.contenedor_guias.forEach((value, index) => {
                            if (value.hawb == data.hawb_numero) {
                                this.contenedor_guias[index].valor = data.hawb_monto;
                            }
                        })

                        const pos = this.contenedor_guias.findIndex(
                            x => x.hawb === data.hawb_numero
                        );
                        if (pos >= 0) {
                            this.contenedor_guias[pos].usuario = usuario
                            this.contenedor_guias[pos].totalProcesado = data.hawb_monto
                        }

                        const url = c_REMOTE_URL + "ims/aplicar_guia";

                        const result = await axios.post(url, data);

                        console.log(result);

                        this.hawb_numero = null;
                        this.hawb_tabla_lineas = [];

                        this.hawb_alert_message = null;
                        this.hawb_alert_message2 = null;
                    } else {
                        this.hawb_alert_message2 = "info";
                    }
                } catch (exception) {
                    // alert("ERROR: " + exception);
                }
            },
            async hawb_undo_aplicar() {
                try {

                    await this.dlg_open("JetBox = IMS =", "Desea devolver la aplicacion de la guía ?", this.dlg_options)

                    const usuario = this.getUser().username;

                    const data = {
                        contenedor_id: this.contenedor.id,

                        hawb: this.hawb,
                        hawb_monto: this.hawb_monto,
                        hawb_numero: this.hawb_numero,
                        lineas: this.hawb_tabla_lineas,
                        usuario
                    };

                    this.contenedor_guias.forEach((value, index) => {
                        if (value.hawb == data.hawb_numero) {
                            this.contenedor_guias[index].valor = 0;
                        }
                    })

                    const pos = this.contenedor_guias.findIndex(
                        x => x.hawb === data.hawb_numero
                    );
                    if (pos >= 0) {
                        this.contenedor_guias[pos].usuario = ''
                        this.contenedor_guias[pos].totalProcesado = 0
                    }

                    const url = c_REMOTE_URL + "ims/undo_aplicar_guia";

                    const result = await axios.post(url, data);

                    console.log(result);

                    this.hawb_numero = null;
                    this.hawb_tabla_lineas = [];

                    this.hawb_alert_message = null;
                    this.hawb_alert_message2 = null;
                } catch (exception) {
                    // alert("ERROR: " + exception);
                }
            },
            async exportar() {
                try {
                    let url = c_REMOTE_URL + "ims/excel/" + this.contenedor.numero_contenedor;
                    if (this.contenedor.numero_contenedor.substr(0, 4) == "Next") {
                        url = c_REMOTE_URL + "ims/excel/NEXTDAY";
                    }
                    console.log('url :>> ', url);
                    // alert(url)

                    const result = await axios.get(url);
                    const excelUrl = result.data.url;

                    window.open("/" + excelUrl, "_blank");
                } catch (error) {
                    console.log(JSON.stringify(error));
                }
            },
            async verFactura() {
                try {
                    const previo = this.imFactura;
                    const hawb = this.hawb_numero;

                    if (hawb) {
                        const imageUrl = c_REMOTE_URL + "ims/documento/" + hawb;

                        // alert("imageUrl: " + imageUrl)
                        console.log('previo :>> ', previo);
                        console.log('imageUrl :>> ', imageUrl);

                        if (this.imFactura === "/NoImage.png") {
                            this.imFactura = imageUrl;
                        } else {
                            if (previo == imageUrl) {
                                this.imFactura = "/NoImage.png";
                            } else {
                                this.imFactura = imageUrl;
                            }
                        }
                    } else {
                        this.imFactura = "/NoImage.png";
                    }
                } catch (error) {
                    console.log('error :>> ', error);
                    // alert(error ? "ERROR: " + JSON.stringify(error) : "error")
                }
            },
            async editArticulos(item) {
                try {
                    const url = c_REMOTE_URL + "ims/guia/" + item.hawb;

                    const result = await axios.get(url);

                    this.hawb_tabla_lineas = result.data.data;

                    this.items = [];
                    this.hawb_id = item.id
                    this.hawb_numero = item.hawb
                    this.hawb_cliente = item.consignatario
                    this.hawb_monto = item.valor
                    this.hawb_documento_compra = item.documento_compra

                    this.imFactura = "/NoImage.png";
                    this.verFactura();


                    if (item.modalidad === ' ') {
                        this.hawb_modalidad == ' '
                    } else if (item.modalidad == '0') {
                        this.hawb_modalidad = 'MODALIDAD: ECONOMY'
                    } else if (item.modalidad == 'E') {
                        this.hawb_modalidad = 'MODALIDAD: ECONOMY'
                    } else if (item.modalidad == 'C') {
                        this.hawb_modalidad = 'MODALIDAD: NEXT DAY'
                    } else if (item.modalidad == 'T') {
                        this.hawb_modalidad = 'MODALIDAD: SAVER'
                    } else {
                        this.hawb_modalidad = 'MODALIDAD: ?' + item.modalidad + '?'
                    }
                } catch (error) {
                    console.log('error :>> ', error);
                    alert(error ? error.response : "error")
                }
            },
            async syncMiami() {
                const url = c_REMOTE_URL + "ims/refrescar";

                const result = await axios.post(url);

                console.log(JSON.stringify(result));
                alert("== SINCRONIZACION EXITOSA !!! ==");
            },
            async refrescarContenedores() {
                try {
                    const result = await axios.get(c_REMOTE_URL + "ims/contenedores");

                    this.contenedores_entries = CONTENEDOR_NEXT_DAY.concat(
                        result.data.data
                    );
                } catch (err) {
                    alert("ERROR: " + JSON.stringify(err));
                }
            },
            cargarGuias() {
                this.marcarCheckox = true;
                if (this.contenedor.id || this.contenedor.fecha_str === "MODALIDAD") {
                    this.hawb_numero = null;

                    const url = c_REMOTE_URL + "ims/guias/" + this.contenedor.id;
                    axios
                        .get(url)
                        .then(result => {
                            this.contenedor_guias = result.data.data;
                        })
                        .catch(err => {
                            alert("ERROR: " + JSON.stringify(err));
                        });
                } else {
                    alert("Seleccione el contenedor para continuar");
                }
            },
            marcarGuias() {
                const url = c_REMOTE_URL + "ims/guias_completas/" + this.contenedor.id;

                if (this.contenedor.id || this.contenedor.fecha_str === "MODALIDAD") {
                    this.marcarCheckox = !this.marcarCheckox;

                    if (this.marcarCheckox == false) {

                        axios
                            .get(url)
                            .then(result => {
                                const values = result.data.guias
                                this.contenedor_guias.forEach(guia => guia.cerrado = values.some(x => guia.hawb === x.hawb));
                            })
                            .catch(err => {
                                console.log('err :>> ', err);
                                alert("ERROR: " + JSON.stringify(err));
                            });

                    } else {
                        this.contenedor_guias.forEach(x => x.cerrado = false)
                    }
                } else {
                    alert("Seleccione el contenedor para continuar");
                }
            },
            async cerrarGuias() {
                try {
                    if (this.contenedor.id || this.contenedor.fecha_str === "MODALIDAD") {
                        const data = {
                            cerrados: this.contenedor_guias.filter(x => x.cerrado).map(x => x.hawb),
                            abiertos: this.contenedor_guias.filter(x => !x.cerrado).map(x => x.hawb)
                        }

                        await this.dlg_open("JetBox = IMS =", "Desea cerrar las guías marcadas ?", this.dlg_options)

                        const url = c_REMOTE_URL + "ims/cerrar_guias/";

                        await axios.post(url, data);
                        /*
                                            this.hawb_numero = null;
                                            const url = c_REMOTE_URL + "ims/guias/" + this.contenedor.id;
                                            axios
                                                .get(url)
                                                .then(result => {
                                                    this.contenedor_guias = result.data.data;
                                                })
                                                .catch(err => {
                                                    alert("ERROR: " + JSON.stringify(err));
                                                });
                        */
                    } else {
                        alert("Seleccione el contenedor para continuar");
                    }
                } catch (error) {
                    console.log(JSON.stringify(error));
                }
            },
            async cerrarGuia(value) {
                try {
                    if (!value.cerrado) {

                        let item = value;
                        await this.dlg_open("JetBox = IMS =", "Desea cerrar la guía #" + value.hawb, this.dlg_options)

                        const url = c_REMOTE_URL + "ims/cerrar_guia/" + item.hawb;

                        await axios.post(url);

                        value.cerrado = true
                    }
                } catch (error) {
                    console.log(JSON.stringify(error));
                }
            },
            dlg_open(title, message, options) {
                this.dlg_dialog = true
                this.dlg_title = title
                this.dlg_message = message
                this.dlg_options = Object.assign(this.dlg_options, options)

                return new Promise((resolve, reject) => {
                    this.dlg_resolve = resolve
                    this.dlg_reject = reject
                })
            },
            dlg_agree() {
                this.dlg_dialog = false
                this.dlg_resolve("Confirmacion aceptada")
            },
            dlg_cancel() {
                this.dlg_dialog = false
                this.dlg_reject("Confirmacion rechazada")
            }
        },
        computed: {
            hawb_partidas() {
                return this.hawb_search_entries.map(entry => {
                    const descripcion =
                        entry.descripcion.length > this.descriptionLimit
                            ? entry.descripcion.slice(0, this.descriptionLimit) + "..."
                            : "" + JSON.stringify(entry.descripcion);

                    return Object.assign({}, entry, { descripcion });
                });
            }
        },
        watch: {
            async hawb_sync(val) {
                if (val && val.trim().length > 3) {
                    const url =
                        c_REMOTE_URL + "ims/consultar_arancel/" + encodeURIComponent(val);

                    const result = await axios.get(url);

                    const values = result.data.data;

                    this.hawb_search_count = values.length;
                    this.hawb_search_entries = values;
                }
            }
        },
        created() {

            this.refrescarContenedores();
        }
    };
</script>

<style scoped>
    /deep/ h4 {
        font-size: 0.81em;
    }
    /deep/ thead tr {
        background-color: #eaecee;
        font-weight: bolder;
    }
    /deep/ tbody tr:nth-child(even) {
        background-color: #eaf2f8;
    }
    /deep/ tbody tr:nth-child(odd) {
        background: #f8f9f9;
    }

    /deep/ input[type='number'] {
        text-align: right;
    }

    /deep/ div.centered {
        text-align: center;
    }
</style>
